import React from "react";
import { AdviceCard, Button, Text, StepsBloc } from "../../../../components";
import {
  AdviceCardContainer,
  ButtonContainer,
  StepsBlocContainer,
  SubTitleContainer,
  TitleContainer,
} from "./styled-components";

const PositiveResponse = () => {
  return (
    <>
      <TitleContainer>
        <Text size="40px" weight={700} lineHeight="52px" align="center">
          Le Défenseur des droits <br />
          <span>semble pouvoir vous aider</span>.
        </Text>
      </TitleContainer>
      <SubTitleContainer>
        <Text size="18px" align="center" color="grey400">
          Vous pouvez remplir le formulaire en ligne pour créer votre dossier.
        </Text>
      </SubTitleContainer>
      <AdviceCardContainer>
        <AdviceCard />
      </AdviceCardContainer>
      <ButtonContainer>
        <Button href="https://formulaire.defenseurdesdroits.fr/code/afficher.php">
          <Text size="18px" weight={700} lineHeight="16px" color="white">
            Créer mon dossier
          </Text>
        </Button>
      </ButtonContainer>
      <StepsBlocContainer>
        <StepsBloc />
      </StepsBlocContainer>
    </>
  );
};

export default PositiveResponse;
